import { getCPS } from './general';

export const getParsedCPS = (psychiatry, cps) => {
  return psychiatry ? getCPS(cps.map(el => `p${el}`)) : getCPS(cps);
}
